import { Component } from '@gondel/core';
import { GondelJqueryComponent } from '@gondel/plugin-jquery';
import addComponentAnimation from '@swisslife/shared-ui/src/utils/animations/js/animations';
import '@swisslife/patterns-base/src/atoms/image/js/image';

// The @Component decorator will connect the class with `data-g-name="SegmentTeaser"` elements.
@Component('SegmentTeaser')
export class SegmentTeaser extends GondelJqueryComponent {
	private controllers: any[] = Array();

	public async start() {
		this.controllers = await addComponentAnimation(this.$ctx);
	}

	public stop() {
		for (const controller of this.controllers) {
			controller.destroy(true);
		}
	}
}
